import React, {FC, Fragment} from 'react';
import {connect} from "react-redux";
import Mixer from "../../components/Mixer";
import NavBar from "../../components/NavBar";
import {getRandomMix} from "../../modules/Mixer";
import {setActivePage} from '../../modules/System';
import Header from "../../components/Header";

interface IMixerMainPage {
    activePage: string,
    getRecommendedMixes: any,
    setActivePage: any,
}

const MixerMainPage: FC<IMixerMainPage> = ({
                                               getRecommendedMixes,
                                               activePage,
                                               setActivePage,
                                           }) => {

    return (
        <Fragment>
            <Header isContentCenter>
                <span
                    className="header__standard-text"
                >
                    Миксер
                </span>
            </Header>
            <Mixer
                getRecommendedMixes={getRecommendedMixes}
            />
            <NavBar
                setActivePage={setActivePage}
                activePage={activePage}
            />
        </Fragment>
    )
};

const mapStateToProps = (state: any) => ({
    activePage: state.system.activePage,
});


const mapDispatchToProps = (dispatch: any) => ({
    getRecommendedMixes: () => dispatch((getRandomMix())),
    setActivePage: (page: string) => dispatch((setActivePage(page))),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MixerMainPage)

